import React from 'react';
import { toPlayableMediaUrl } from '../utils/r2Upload';

export function VideoRecordingPreview({ src, width = 200, height = 112 }) {
  const url = toPlayableMediaUrl(src);
  if (!url) return <span className="text-muted">Yok</span>;

  const showFirstFrame = (el) => {
    if (!el) return;
    try {
      if (el.currentTime < 0.05) el.currentTime = 0.15;
    } catch (_) {}
  };

  return (
    <video
      src={`${url}#t=0.15`}
      controls
      preload="metadata"
      playsInline
      muted
      onLoadedMetadata={(e) => showFirstFrame(e.currentTarget)}
      style={{
        width,
        height,
        objectFit: 'cover',
        borderRadius: 8,
        background: '#111',
        display: 'block'
      }}
    />
  );
}

export function AudioRecordingPreview({ src }) {
  const url = toPlayableMediaUrl(src);
  if (!url) return <span className="text-muted">Yok</span>;

  return (
    <audio
      src={url}
      controls
      preload="metadata"
      style={{ width: 240, height: 36 }}
    />
  );
}
